import React, { ComponentProps } from "react";
import { cls } from "cls";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
interface SaleHeadlineProps extends ComponentProps<"span"> {
  originalPrice: number;
  salePrice: number;
  unitOfMeasure: string;
  priceLabel?: string;
}
const SaleHeadline = ({
  originalPrice,
  salePrice,
  unitOfMeasure,
  priceLabel,
  className
}: SaleHeadlineProps) => <>
    <span className={cls("text-black font-bold bg-yellow-400 rounded-sm antialiased", className)}>
      Sale
    </span>
    <span aria-hidden="true">reg</span>&nbsp;
    {priceLabel ?? formatAsCurrency.formatIfUndefined(originalPrice)}
    <span className="sr-only">
      now {`${formatAsCurrency.formatIfUndefined(salePrice)}/${unitOfMeasure}`}
    </span>
  </>;
export default SaleHeadline;